/* eslint-disable @next/next/no-img-element */
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { isEmpty } from 'lodash';
import Product from "components/shop/product";

export default function EditorComponent({ images }) {
    const [display, setDisplay] = useState(false);
    let products = [];

    (images || []).forEach(image => {
        const productNotInList = image.tagged_products.filter(x => !products.some(product => product.sku === x.sku));
        products = products.concat(productNotInList);
    });

    return <>
        <div className="btnMore">
            <button className="btn btn--blue" onClick={() => setDisplay(true)}>Xem sản phẩm</button>
        </div>
        <Modal show={display} onHide={() => setDisplay(false)} className="productsLst-modal">
            <Modal.Header closeButton>
                <h5 className="modal-title">{!isEmpty(products) ? 'Sản phẩm trong bài' : 'Thông báo'}</h5>
            </Modal.Header>
            <Modal.Body >
                <div className="productsLst flashSale-sp">
                    {!isEmpty(products) ? products.map((item, index) => {
                        return <Product item={item} isHorizon={true} key={index + item.sku}/>;
                    })
                        : 'Bài viết không có sản phẩm đính kèm!'
                    }
                </div>
            </Modal.Body>
        </Modal>
    </>;
}
